import Form from 'components/form/form.component';
import IncButton from 'components/inc-button/inc-button.component';
import { useFormContext } from 'react-hook-form';
import CVVForm from './cvv-form/cvv-form.component';
import { Provider as SpreedlyFormProvider } from '../spreedly-form.context';
import { useTranslation } from 'react-i18next';
import { spreedlyFormSubmit, useSpreedlyForm } from '../spreedly-form.hooks';

const SpreedlyCVVRecacheForm = ({
  paymentInstrument,
  initOrderAttributes,
  onSuccess,
  onError,
  setLoading,
  isLoading,
}) => {
  const { t } = useTranslation();

  const value = useSpreedlyForm(
    initOrderAttributes,
    onSuccess,
    onError,
    paymentInstrument,
  );
  const { handleSubmit } = useFormContext();

  return (
    <Form>
      <SpreedlyFormProvider value={value}>
        <CVVForm />
      </SpreedlyFormProvider>
      <IncButton
        fullWidth
        onClick={spreedlyFormSubmit(handleSubmit, _data => {
          setLoading(true);
          window.Spreedly.recache();
        })}
        disabled={isLoading}
        data-testid="CVVForm.IncButton"
      >
        {t('checkout.payment.spreedly.submit')}
      </IncButton>
    </Form>
  );
};

export default SpreedlyCVVRecacheForm;
